//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {page, deleteFlowData} from '@/api/flow/flow';
import {dateFormat} from '@/utils/common';
import {Toast } from 'mint-ui';
import SlipDel from 'vue-slip-delete'
export default {
    name: "flowApplyList",
    components: {
      SlipDel
    },
    data: function () {
        return {
            listQuery: {
                flowTitle: "",
                currentPage:1, // 当前页
                pageSize:5, // 每页数据
                filter:'0' // 是否需要用户过滤 1：需要 0：不需要
            },
            refreshing: false,
            loading: false,
            listData:[],
            filterOpen: false,
            trigger: null
        }
    },
    created() {
        // 加载数据
        this.loadData();
    },
    mounted: function(){
        this.trigger = this.$refs.filterBtn.$el;
    },
    methods: {
        //时间格式化
        dateFormatter(date) {
            return dateFormat(date);
        },
        // 查找
        searchEvent(event){
            if(event.keyCode == 13){
                this.listQuery.currentPage=1;
                this.loadData();
            }
        },
        // 清空条件
        clearFilter(){
            this.listQuery.flowTitle='';
            // 当前页重置
            this.listQuery.currentPage=1;
            this.loadData();
        },
        // 数据刷新(下拉)
        refresh () {
            this.refreshing = true;
            this.$refs.container.scrollTop = 0;
            this.listQuery.currentPage= 1;
            setTimeout(() => {// refreshing=true 的情况下加载
                this.loadData();
                this.refreshing = false;
            }, 600);
        },
        // 数据加载(上拉)
        load(){
            this.loading = true;
            setTimeout(() => {
                this.listQuery.currentPage++;
                // 加载
                this.loadData2();
                this.loading = false;
            }, 600);
        },
        // 加载
        loadData(){
            var condition = {
                'flowTitle': this.listQuery.flowTitle,
                'page': this.listQuery.currentPage,
                'multiSort': JSON.stringify([{'sortName': 'create_time','sortOrder': 'DESC'}]),
            };
            page(condition).then(response => {
                // 刷新情况下
                this.listData = response.data;
            });
        },
        // 加载数据
        loadData2(){
            var condition = {
                'flowTitle': this.listQuery.flowTitle,
                'page': this.listQuery.currentPage,
                'multiSort': JSON.stringify([{'sortName': 'create_time','sortOrder': 'DESC'}]),
            };
            page(condition).then(response => {
                // 加载数据情况下
                var data = response.data;
                for(var i=0;i<data.length;i++){
                    this.listData.push(data[i]);
                }
            });
        },
        // 进入明细
        itemClick(row){
            if (row.apprState == '草稿'){
                this.$router.push({
                    name:'流程编辑',
                    path: '/app/workRep/flowApplyEdit',
                    query:{
                        operType: 'edit',
                        flowId: row.id
                    }
                });
            }else{
                this.$router.push({
                    name:'流程详细',
                    path: '/app/workRep/flowApplyDetail',
                    query:{
                        flowId: row.id
                    }
                });
            }
        },
        //进入流程申请页面
        flowApplyClick(){
            this.$router.push({
                name:'流程编辑',
                path: '/app/workRep/flowApplyEdit',
                query:{
                    operType: 'add'
                }
            });
        },
        del(index, row){
            if (row.apprState == '草稿'){
              var query = {flowId: row.id};
              this.$confirm('是否确认删除?', '提示', {
                  cancelButtonText: '取消',
                  confirmButtonText: '确定',
                  type: 'warning'
              }).then(({ result }) => {
                  if(result){
                      deleteFlowData(query).then(response => {
                        Toast({message: '删除成功!', duration: 1500, position: 'middle', className: "success" });
                        this.loadData();
                      });
                  }else{
                      Toast({message: '已取消操作', duration: 1500, position: 'middle', className: "warning" });
                  }
              });
            }else{
              Toast({message: '不可删除！', duration: 1500, position: 'middle', className: "warning" });
            }
        },
        //滑动
        slipOpen(vm) {
          // 无需手动关闭
        },
        // 筛选
        filter(){
            this.filterOpen = !this.filterOpen;
        },
        // 返回工作台
        goback(){
            this.$router.push({ name:'workbench'});
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/flow/flowApplyList.vue